import { Filters } from '@/features/filters/types';
import { sizesOptions } from '@/features/listing/components/search/filters/size-filter';
import { ListingSearchParams } from '@/features/listing/components/search/search-provider';
import { capitalizeFirstLetter } from '@/lib/utils/string';

type BaseFilter = {
  name: string;
  slug: string;
};

export const resolveFilterLabels = (
  filters: Filters | undefined,
  params: ListingSearchParams,
  categoryFilter: string | null,
) => {
  const mapLabels = (
    options: BaseFilter[] | undefined,
    selectedValues: string[] | null,
    type: string,
  ) =>
    (options || [])
      .filter((option) => selectedValues?.includes(option.slug))
      .map((option) => ({
        type,
        label: option.name,
        value: option.slug,
      }));

  const mapSizeLabels = (
    options: { label: string; value: string }[],
    selectedValues: string[] | null,
    type: string,
  ) => {
    return options
      .filter((option) => selectedValues?.includes(option.value))
      .map((option) => ({
        type,
        label: `${capitalizeFirstLetter(type)} ${option.label}`,
        value: option.value,
      }));
  };

  const categoryLabel = mapLabels(
    filters?.categories,
    [categoryFilter || ''],
    'categories',
  )[0];

  return {
    categoryLabel,
    allFilters: [
      ...mapLabels(filters?.styles, params.styles, 'styles'),
      ...mapLabels(filters?.colors, params.colors, 'colors'),
      ...mapLabels(filters?.conditions, params.conditions, 'conditions'),
      ...mapLabels(filters?.occasions, params.occasions, 'occasions'),
      ...mapSizeLabels(sizesOptions, params.chest, 'chest'),
      ...mapSizeLabels(sizesOptions, params.waist, 'waist'),
    ],
  };
};

export function transformOptions(items: BaseFilter[]) {
  if (!items) {
    return [];
  }

  return items?.map((item) => ({
    ...item,
    href: item.slug,
    label: item.name,
  }));
}
